export type Tone = "primary" | "accent" | "secondary";

export const toneBadge: Record<Tone, string> = {
  primary: "bg-primary-100 text-primary-700 border-primary-200",
  accent: "bg-accent-100 text-accent-800 border-accent-200",
  secondary: "bg-secondary-100 text-secondary-800 border-secondary-200",
};

export const toneDot: Record<Tone, string> = {
  primary: "bg-primary-500",
  accent: "bg-accent-500",
  secondary: "bg-secondary-500",
};

export const toneIconWrap: Record<Tone, string> = {
  primary: "bg-primary-500 text-background-50",
  accent: "bg-accent-500 text-foreground-950",
  secondary: "bg-secondary-500 text-background-50",
};